import { render, staticRenderFns } from "./box10.vue?vue&type=template&id=95052854&scoped=true&"
import script from "./box10.vue?vue&type=script&lang=js&"
export * from "./box10.vue?vue&type=script&lang=js&"
import style0 from "./box10.vue?vue&type=style&index=0&id=95052854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95052854",
  null
  
)

export default component.exports